// extracted by mini-css-extract-plugin
module.exports = {"newAddress":"NewAddress_newAddress__1SEdT","required":"NewAddress_required__3lKrs"};